import _ from 'underscore';

export const buildDefaultDataProperty = (props) => {
  const {
    label,
    data,
    styles,
    dynamicProps,
  } = props;

  const baselineProperty = {
    type: 'property-row',
    propertyLabel: {
      label,
    },
    components: {
      data: {
        type: 'data',
        data,
        dynamicProps,
      },
    },
  };

  return _.extend(baselineProperty, { styles });
};
